import React, { useState } from 'react'
import './styles/component-styles.scss'
import { DotsThree, Eye, EyeSlash, Pencil, Trash, Plus } from '@phosphor-icons/react'
import { Dropdown } from 'antd'
import DiscountCode from '../Modals/Discount/DiscountCode'

import ButtonSpinner from 'components/global/ButtonSpinner'
import AlertModal from 'helper/AlertModal'
import ViewDiscount from '../Modals/Discount/ViewDiscount'
import { useUpdateClassesDiscountStatus, useRemoveClassesDiscountCode } from 'api/Classes/Step6Tickets/Tickets'
import { ClassesDiscountCodeResponse } from 'types/Classes/Classes'
import { formatDate } from 'utils/dateUtils'


const Discounts: React.FC<any> = ({ data, discountModalOpen, setDiscountModalOpen, selectedDiscountData, setSelectedDiscountData }) => {
  const [viewDiscount, setViewDiscount] = useState<boolean>(false)
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const { mutate: updateCodeStatus, isLoading: updateCodeStatusLoading } =
    useUpdateClassesDiscountStatus()
  const { mutate: deleteDiscountCode, isLoading: deleteDiscountLoading } =
    useRemoveClassesDiscountCode()

      const alertModalData = {
    name: 'Delete',
    heading: 'Delete discount',
    message1: 'Are you sure you want to delete discount?',
  }

  const handleYesDelete = () => {
    deleteDiscountCode(
      selectedDiscountData._id as string,
      {
        onSuccess: () => setAlertModal(false),
        onError: () => setAlertModal(false),
      },
    )
  }

  const handleMenuClick = (
    operation: 'edit' | 'view' | 'visibility' | 'delete',
    clickedDiscount: ClassesDiscountCodeResponse,
  ) => {
    if (operation === 'edit') {
      setSelectedDiscountData(clickedDiscount)
      setDiscountModalOpen(true)
    } else if (operation === 'visibility') {
      setSelectedDiscountData(clickedDiscount)
      const status = clickedDiscount.status === 'active' ? 'disabled' : 'active'
      updateCodeStatus({ discountCodeId: clickedDiscount._id, payload: { status } })
    } else if (operation === 'delete') {
      setSelectedDiscountData(clickedDiscount)
      setAlertModal(true)
    } else {
      setSelectedDiscountData(clickedDiscount)
      setViewDiscount(true)
    }
  }

  const manageOptions = (discountData: ClassesDiscountCodeResponse) => [
    {
      key: 'edit',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('edit', discountData)}
        >
          <Pencil size={20} color="#000" />
          <p className="text-14 w-500">Edit Code</p>
        </div>
      ),
    },
    {
      key: 'view',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('view', discountData)}
        >
          <Eye size={20} color="#000" />
          <p className="text-14 w-500">View Discount</p>
        </div>
      ),
    },
    {
      key: 'visibility',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('visibility', discountData)}
        >
          {discountData.status === 'active' ? (
            <EyeSlash size={20} color="#000" />
          ) : (
            <Eye size={20} color="#000" />
          )}
          <p className="text-14 w-500">
            Make {discountData.status === 'active' ? 'Disable' : 'Enable'}
          </p>
        </div>
      ),
    },
    {
      key: 'delete',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('delete', discountData)}
        >
          <Trash size={20} color="#ff6961" />
          <p className="text-14 w-500 danger-txt">Delete Discount</p>
        </div>
      ),
    },
  ]

  return (
    <>
      <div className="mt-20px">
        {/* Card View - Top Section */}
        <div className="mb-30px">
          <div className="grid-50">
            {Array.isArray(data) && data.map((discount: ClassesDiscountCodeResponse) => {
              return (
                <div key={discount._id}>
                  {selectedDiscountData?._id === discount._id &&
                    (updateCodeStatusLoading || deleteDiscountLoading) ? (
                    <div
                      className="w-full flex align-center justify-center"
                      style={{ height: '120px' }}
                    >
                      <ButtonSpinner size={20} color="#000" />
                    </div>
                  ) : (
                    <div
                      className="ticket-main-cont discount-cont"
                      style={{ backgroundColor: '#ff69b4' }}
                    >
                      <div className="content">
                        <div className="flex justify-between align-center">
                          <h2 className="text-18 w-600">
                            {discount.code}
                          </h2>
                          {updateCodeStatusLoading ? (
                            <ButtonSpinner size={20} color={'#000'} />
                          ) : discount.status === 'active' ? (
                            <Eye size={20} color="#000" />
                          ) : (
                            <EyeSlash size={20} color="#000" />
                          )}
                        </div>

                        <p className="text-14 w-500">{`${
                          discount.totalLimit ? 
                            `${discount.totalLimit} days` : 
                            'Unlimited'
                        } for ${discount.discount}${discount.type === 'percent' ? '%' : '$'}`}</p>
                        
                        <Dropdown
                          menu={{ items: manageOptions(discount) }}
                          placement="bottomLeft"
                          arrow={false}
                          className={`ml-20px mr-10px ${
                            updateCodeStatusLoading && 'no-pointer-events'
                          }`}
                          overlayStyle={{ width: '300px' }}
                          trigger={['click']}
                        >
                          <button className="ticket-button pointer">Manage</button>
                        </Dropdown>
                      </div>
                      <div className="dull-color"></div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>

        {/* Table View - Bottom Section */}
        <div className="discount-cont">
          <div className="discount-header flex gap-10px">
            <h3 className="text-13 w-600 heading">Code</h3>
            <h3 className="text-13 w-600 heading">Discount</h3>
            <h3 className="text-13 w-600 heading">Used</h3>
            <h3 className="text-13 w-600 heading">Limit</h3>
            <h3 className="text-13 w-600 heading">Expiry</h3>
          </div>
          <div>
            {Array.isArray(data) && data.map((discount: ClassesDiscountCodeResponse) => {
              return (
                <>
                  {selectedDiscountData?._id === discount._id &&
                    (updateCodeStatusLoading || deleteDiscountLoading) ? (
                    <div
                      className="w-full flex align-center justify-center"
                      style={{ height: '60px' }}
                    >
                      <ButtonSpinner size={20} color="#000" />
                    </div>
                  ) : (
                    <div className="flex gap-10px discount-body">
                      <p className="body-content">{discount.code}</p>
                      <p className="body-content">{`${discount.discount}${discount.type === 'percent' ? '%' : '$'
                        }`}</p>
                      <p className="body-content">0</p>
                      <p className="body-content">{discount.totalLimit || 'no limit'}</p>
                      <p className="body-content">
                        {formatDate(discount.expiry)}
                      </p>
                      <Dropdown
                        menu={{ items: manageOptions(discount) }}
                        placement="bottomRight"
                        arrow={false}
                        className={``}
                        overlayStyle={{ width: '300px' }}
                        trigger={['click']}
                      >
                        <DotsThree size={20} color="#000" className="pointer" />
                      </Dropdown>
                    </div>
                  )}
                </>
              )
            })}
          </div>
        </div>

        {(!data || data.length === 0) && (
          <div className="text-center py-30px">
            <p className="text-14 w-400 text-gray">No discount codes added yet</p>
          </div>
        )}
      </div>

      


      {viewDiscount && (
        <ViewDiscount
          openModal={viewDiscount}
          closeModal={setViewDiscount}
          id={selectedDiscountData._id}
        />
      )}

      {alertModal && (
        <AlertModal
          isModalVisible={alertModal}
          setIsModalVisible={setAlertModal}
          data={alertModalData}
          onYesClick={handleYesDelete}
          loading={deleteDiscountLoading}
        />
      )}
    </>
  )
}

export default Discounts
